
$( document ).ready(function() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('code')) {
        const code = urlParams.get('code');
        if (code != null && typeof code != "undefined" && code != "") {
            if (_ceml !== null && typeof _ceml !== 'undefined') {
                const settings = {
                    "url": "https://yammie-api.herokuapp.com/api/v1/shop/discord-connect",
                    "method": "POST",
                    "timeout": 0,
                    "headers": { "Content-Type": "application/json" },
                    "data": JSON.stringify({ "email": _ceml, "code": code }),
                };

                $.ajax(settings).done(function (res) {
                    if (res.data != null && typeof res.data !== 'undefined') {
                        console.log("Discord Connect: Success!");
                    }
                });
            }
        }
    }
});
